import React, { useEffect, useState } from 'react';
import adminApi from './adminApi';
import { Karte, Chip, ZustellChip, Leer, Fehler, zeit } from './bausteine';

const TabHeute = () => {
  const [daten, setDaten] = useState(null);
  const [risiken, setRisiken] = useState(null);
  const [fehler, setFehler] = useState(null);

  useEffect(() => {
    Promise.all([adminApi.overview(), adminApi.risks()])
      .then(([o, r]) => { setDaten(o); setRisiken(r); })
      .catch((e) => setFehler(e.response?.data?.error || e.message));
  }, []);

  if (fehler) return <Fehler>{fehler}</Fehler>;
  if (!daten) return <Leer>Lade …</Leer>;

  const { laeufe, bilanz, meldungen } = daten;
  const lauf = (l, name) => {
    if (!l) return <Chip farbe="grau">{name}: nicht gelaufen</Chip>;
    const farbe = l.status === 'completed' ? 'gruen' : l.status === 'failed' ? 'rot' : 'gelb';
    return <Chip farbe={farbe}>{name}: {l.status} ({zeit(l.startedAt)})</Chip>;
  };

  return (
    <div className="space-y-6">
      <Karte titel={`Läufe am ${daten.datum}`}>
        <div className="flex flex-wrap gap-2 mb-4">
          {lauf(laeufe.tagesmeldung, 'Tagesmeldung')}
          {lauf(laeufe.alarmierung, 'Alarmierung')}
        </div>

        <div className={`rounded-lg p-4 border ${bilanz.stimmig
          ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
          <p className="font-medium text-sm mb-1">
            {bilanz.stimmig
              ? `Bilanz stimmig: ${bilanz.tatsaechlich} von ${bilanz.erwartet} Meldungen`
              : 'Bilanz nicht plausibel'}
          </p>
          {!bilanz.stimmig && (
            <ul className="list-disc list-inside text-sm text-red-800">
              {bilanz.befunde.map((b) => <li key={b}>{b}</li>)}
            </ul>
          )}
        </div>
      </Karte>

      <Karte titel={`Risiken (${risiken.anzahl})`}>
        {risiken.anzahl === 0 ? (
          <Leer>Keine Auffälligkeiten.</Leer>
        ) : (
          <ul className="space-y-2">
            {risiken.risiken.map((r, i) => (
              <li key={i} className="flex items-start gap-3 text-sm">
                <Chip farbe={r.schwere === 'hoch' ? 'rot' : r.schwere === 'mittel' ? 'gelb' : 'grau'}>
                  {r.schwere}
                </Chip>
                <span>
                  <span className="font-medium">{r.betreutePerson || r.name}</span>
                  {r.betreutePerson && <span className="text-gray-500"> (Konto: {r.name})</span>}
                  {' – '}{r.text}
                </span>
              </li>
            ))}
          </ul>
        )}
      </Karte>

      <Karte titel="Meldungen heute">
        {meldungen.length === 0 ? <Leer>Noch keine Meldungen.</Leer> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 border-b">
                  <th className="py-2 pr-4 font-medium">Person</th>
                  <th className="py-2 pr-4 font-medium">Kanal</th>
                  <th className="py-2 pr-4 font-medium">Gesendet</th>
                  <th className="py-2 pr-4 font-medium">Zustellung</th>
                  <th className="py-2 pr-4 font-medium">Antwort</th>
                  <th className="py-2 font-medium">Alarm</th>
                </tr>
              </thead>
              <tbody>
                {meldungen.map((m) => (
                  <tr key={m.id} className="border-b border-gray-50">
                    <td className="py-2 pr-4">{m.person}</td>
                    <td className="py-2 pr-4">{m.kanal || '–'}</td>
                    <td className="py-2 pr-4 whitespace-nowrap">{zeit(m.sentAt)}</td>
                    <td className="py-2 pr-4">
                      <ZustellChip status={m.zustellung} />
                      {m.zustellfehler && (
                        <span className="block text-xs text-red-600">{m.zustellfehler}</span>
                      )}
                    </td>
                    <td className="py-2 pr-4">
                      {m.beantwortet
                        ? <Chip farbe="gruen">{zeit(m.respondedAt)}</Chip>
                        : <Chip farbe="grau">keine</Chip>}
                    </td>
                    <td className="py-2">
                      {m.alarmUebersprungen
                        ? <Chip farbe="rot" title={m.alarmUebersprungen}>übersprungen</Chip>
                        : m.alarmiert
                          ? <><Chip farbe="gelb">gesendet</Chip>{' '}<ZustellChip status={m.alarmZustellung} /></>
                          : <span className="text-gray-400">–</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <p className="mt-3 text-xs text-gray-500">
          „accepted“ heisst nur, dass der Anbieter die Nachricht angenommen hat.
          Ob sie ankam, meldet er erst später — bei SMS meldet er es gar nicht.
        </p>
      </Karte>
    </div>
  );
};

export default TabHeute;
